import '../lib';
import initTracking from '../lib/init-tracking';
import bindVideoWatching from '../lib/bind-event-tracking/video-watching';
import { experiment } from '../data-stores/ExperimentStore';
import { disable as preLoaderDisable } from '../lib/preloader/preloader';
import { isFacebookApp, waitForFacebookBrowser } from '../lib/wait-for-facebook-browser';
import { renderTo } from '../lib/cmp';
import { setIphoneParamsGlobaly } from '../lib/ios-device-detect';
import { rtlLocales } from '../lib/locale';
import { enableRtl } from '../lib/document-dir-utils';
import { initSentry } from '../lib/sentry';
import smLanding from './sm-landing-appstore-app-1/sm-landing-appstore-app-1';



initSentry();

if (window.SPM_CONFIG && window.SPM_CONFIG.context) {
  window.SPM_CONFIG.context.device = {
    kind: window.detectedDevice
  };
}

if (rtlLocales.includes(experiment.data.locale)) {
  enableRtl();
}

if (isFacebookApp()) {
  waitForFacebookBrowser()
    .then(renderPage)
    .catch((err) => {
      throw new Error(err);
    });
} else {
  renderPage();
}

function renderPage () {
  setIphoneParamsGlobaly();
  const component = smLanding(null, { experiment });

  renderTo(component, document.body, () => {
    preLoaderDisable();

    initTracking();
    bindVideoWatching(document.getElementById('video'));
  });
}




// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/index.js